/* TODO: t() */
import React from 'react';
import { StyleSheet, View } from 'react-native';

import IndexedList from '../../../../support/shared/IndexedList';
import { calculateAddonDates } from '../../../../support/shared/calculateAddonDates';
import { getAttendingDates } from '../../../../support/shared/getAttendingDates';
import { ADDON_OPTIONS } from '../../../../support/constants/addons';

import { RadioGroup, RadioItem } from '../../../uiold';

import { Market } from '../../../../types/shared/Market';
import {
  VendorAddons,
  VendorAddonStatus,
  Field,
} from '../../../../types/shared/Vendor';
import { AddonElementDefinition } from '../../../../types/shared/FormFieldDefinition';
import { Addon } from '../../../../types/shared/Addon';

import { AddonMarketDateSelector } from './AddonMarketDateSelector';

type Props = {
  definition: AddonElementDefinition;
  value: VendorAddons;
  onChange: (id: string, value: VendorAddons) => void;
  markets: IndexedList<Market>;
  addons?: Map<string, Addon> | null | undefined;
  fields: IndexedList<Field>;
  isVendor?: boolean;
};

function AddonElementEditView(props: Props) {
  let { definition, value, onChange, markets, fields, isVendor } = props;

  return (
    <View>
      <View style={styles.rowFlex}>
        <RadioGroup
          selectedValue={value.status}
          alignHorizontal
          onChange={(statusValue) => {
            onChange(definition.id, {
              ...value,
              status: statusValue as VendorAddonStatus,
            });
          }}
        >
          {ADDON_OPTIONS.map((option, i) => {
            return (
              <RadioItem key={i} value={option.value} title={option.title} />
            );
          })}
        </RadioGroup>
      </View>
      {value.status === 'Partial'
        ? markets.mapToArray((market) => {
            let availableDates = getAttendingDates(market, fields);
            let selectedDates = calculateAddonDates(value, market, fields);
            return (
              <AddonMarketDateSelector
                key={market.id}
                market={market}
                status={value.status}
                availableDates={availableDates}
                selectedDates={selectedDates}
                onChange={(datesSelected) => {
                  let newDatesObj = Object.fromEntries(
                    datesSelected.map((date) => [date, 1]),
                  );
                  let datesByMarketId = {
                    ...value.dates,
                    [market.id]: newDatesObj,
                  };
                  onChange(definition.id, { ...value, dates: datesByMarketId });
                }}
                isVendor={isVendor}
              />
            );
          })
        : null}
    </View>
  );
}

let styles = StyleSheet.create({
  rowFlex: { flexDirection: 'row' },
});

export default AddonElementEditView;
